import type { TabbedFlipboardSmallTextCardType } from '@models/ITabbedFlipboard';
import TabbedFlipboardTextCard from './TabbedFlipboardTextCard';

const TabbedFlipboardSmallTextCard = ({
  stat,
  icon,
  body,
  meta,
}: Omit<TabbedFlipboardSmallTextCardType, 'type'>) => (
  <TabbedFlipboardTextCard
    stat={stat}
    icon={icon}
    body={body}
    meta={meta}
    dataTestId="CT-159-Tabbed-Flipboard-Small-Text-Card"
    isSmall
  />
);

export default TabbedFlipboardSmallTextCard;
